import React from "react";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import SmartSurveyResults from "../../../components/smart/LCF402/SurveyResults/SurveyResults";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled from "styled-components";
import PrimaryButton from "../../../components/ui-library/Buttons/PrimaryButton/PrimaryButton";
import history from "../../../modules/history";
import { useTranslation } from "react-i18next";

const SurveyResults = (props) => {
  const { t } = useTranslation();
  const {
    match: {
      params: { participantId, surveyDefinitionId },
    },
    route,
    studies,
    claims,
  } = props;

  const Footer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;
  `;

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        studyId={route.study}
        subtitle=""
        roleName="Participant"
        shouldFetchParticipant={true}
        participantId={participantId}
      />
      {claims?.includes("results.canView") && (
        <SmartSurveyResults
          participantId={participantId}
          surveyDefinitionId={surveyDefinitionId}
        />
      )}
      <Footer>
        <PrimaryButton
          size="sm"
          onClick={() => history.push(`/participant/${participantId ?? ""}`)}
        >
          {t("appText.survey.confirmation.return")}
        </PrimaryButton>
      </Footer>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(SurveyResults);
